// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  overflow: hidden;
  position: relative;
}
.ContactUs .Contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  height: 100%;
  width: 25rem;
  background: var(--Foreground);
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
}
.ContactUs .Contact .ContactImage {
  width: 75%;
  height: 40%;
  transition: opacity 0.3s ease;
}
.ContactUs .Contact .ContactImageDark {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.ContactUs .Contact h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--TextColor);
}
.ContactUs .Contact .ConatactDetail {
  width: 80%;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
}
.ContactUs .Contact .ConatactDetail svg {
  min-width: 1.25rem;
}
.ContactUs .Contact .ConatactDetail svg path {
  fill: var(--AccentColor);
}
.ContactUs .Contact .ConatactDetail span {
  font-size: 0.875rem;
  color: var(--TextColor);
}
.ContactUs .Contact .ConatactDetail .Mail {
  text-decoration: none;
  color: #58A5E5;
  font-size: 0.875rem;
}
.ContactUs .FormContainer {
  flex: 1 1;
  padding: 1.25rem;
  height: 100%;
  background: var(--Foreground);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  transform-origin: top left;
  transform-style: preserve-3d;
  transition: transform 0.3s ease-in-out;
  transform: perspective(1500px) rotateY(-90deg);
}
.ContactUs .FormContainer h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--TextColor);
  line-height: 100%;
}
.ContactUs .FormContainer span {
  color: var(--TextColor);
  font-size: 0.875rem;
  text-align: center;
  text-wrap: balance;
}
.ContactUs .FormContainer .InputSection {
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  width: 60%;
  overflow: auto;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer {
  position: relative;
  width: 100%;
  min-width: 12.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailInput {
  width: 100%;
  height: 2.5rem;
  padding: 0 0.75rem;
  background: transparent;
  border: None;
  outline: None;
  font-size: 0.875rem;
  color: var(--TextColor);
  border-bottom: 2px solid var(--Stroke);
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailInput:-webkit-autofill {
  background-color: transparent;
  box-shadow: 0 0 0 100px white inset;
  -webkit-text-fill-color: var(--TextColor) !important;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailInput:read-only {
  opacity: 0.5;
  cursor: not-allowed;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .Select {
  width: 100%;
  background: transparent;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .Select option {
  background: var(--Background);
  color: var(--TextColor);
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .Select:read-only {
  opacity: 1;
  cursor: pointer;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .TextArea {
  height: 6.25rem;
  padding: 0.75rem 0 0 0.75rem;
  font-size: 0.875rem;
  border: 0.0625rem solid var(--Stroke);
  border-bottom: 0.125rem solid var(--Stroke);
  resize: none;
  border-radius: 0.5rem;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailLabel {
  color: var(--TextColor);
  font-size: 0.875rem;
  position: absolute;
  padding: 0 0.5rem;
  top: 50%;
  left: 0.75rem;
  transform: translateY(-50%);
  text-transform: capitalize;
  transition: 0.2s;
  pointer-events: none;
}
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailInput:not(:placeholder-shown) + .EmailLabel,
.ContactUs .FormContainer .InputSection .LoginInputContainer .EmailInput:focus + .EmailLabel {
  background: var(--Foreground);
  top: 0;
  left: 0.5rem;
  padding: 0 0.25rem;
  font-size: 0.75rem;
  color: var(--AccentColor);
}
.ContactUs .FormContainer .InputSection .Button {
  width: 100%;
  min-height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: none;
  background: var(--AccentColor);
  border-radius: 0.25rem;
  color: #fff;
  font-size: 0.875rem;
  cursor: pointer;
}
.ContactUs .Reveal {
  transform: perspective(1500px) rotateY(0deg);
  border-radius: 1rem;
}
.ContactUs .PinSection {
  position: absolute;
  height: 100%;
  width: 3rem;
  top: 0;
  left: 23.875rem;
  background-repeat: space;
  background-size: 100%;
}
.ContactUs .LoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 1;
}

@media (max-width: 1200px) {
  .ContactUs .FormContainer .InputSection {
    width: 90%;
  }
}
@media (max-width: 824px) {
  .ContactUs .Contact {
    width: 18rem;
    padding-top: 3rem;
    justify-content: flex-start;
  }
  .ContactUs .Contact .ContactImage {
    height: auto;
  }
  .ContactUs .Contact .ConatactDetail {
    width: 100%;
  }
  .ContactUs .FormContainer {
    justify-content: flex-start;
    padding-top: 3rem;
  }
  .ContactUs .PinSection {
    left: 16.875rem;
  }
}
@media (max-width: 600px) {
  .ContactUs {
    flex-direction: column;
  }
  .ContactUs .Contact {
    width: 100%;
    flex: 1 1;
    overflow: auto;
  }
  .ContactUs .Contact .ContactImage {
    height: 30%;
  }
  .ContactUs .FormContainer {
    transform-origin: none;
    transform-style: none;
    transition: none;
    transform: none;
  }
  .ContactUs .Reveal {
    transform: none;
  }
  .ContactUs .PinSection {
    display: none;
  }
}
@media (max-height: 450px) {
  .ContactUs .Contact {
    padding-top: 1rem;
  }
  .ContactUs .Contact .ContactImage {
    display: none;
  }
  .ContactUs .FormContainer {
    padding-top: 1rem;
  }
  .ContactUs .FormContainer .InputSection {
    gap: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ContactUs/ContactUs.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;AADI;EACE,UAAA;EACA,WAAA;EACA,6BAAA;AAGN;AADI;EACE,YAAA;EACA,6BAAA;AAGN;AADI;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AAGN;AADI;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;AAGN;AAFM;EACE,kBAAA;AAIR;AAHQ;EACE,wBAAA;AAKV;AAFM;EACE,mBAAA;EACA,uBAAA;AAIR;AAFM;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAIR;AAAE;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;AAEJ;AADI;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAGN;AADI;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAGN;AADI;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AAGN;AAFM;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIR;AAHQ;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AAKV;AAJY;EACE,6BAAA;EACA,mCAAA;EACA,oDAAA;AAMd;AAHQ;EACE,YAAA;EACA,mBAAA;AAKV;AAHQ;EACE,WAAA;EACA,uBAAA;AAKV;AAJU;EACE,6BAAA;EACA,uBAAA;AAMZ;AAHQ;EACE,UAAA;EACA,eAAA;AAKV;AAHQ;EACE,eAAA;EACA,4BAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,YAAA;EACA,qBAAA;AAKV;AAHQ;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;AAKV;AAHQ;;EAEM,6BAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAKd;AAFM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAIR;AAAE;EACE,4CAAA;EACA,mBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAEJ;;AAEA;EAGM;IACE,UAAA;EADN;AACF;AAMA;EAEI;IACE,YAAA;IACA,iBAAA;IACA,2BAAA;EALJ;EAMI;IACE,YAAA;EAJN;EAMI;IACE,WAAA;EAJN;EAOE;IACE,2BAAA;IACA,iBAAA;EALJ;EAOE;IACE,eAAA;EALJ;AACF;AASA;EACE;IACE,sBAAA;EAPF;EAQE;IACE,WAAA;IACA,SAAA;IACA,cAAA;EANJ;EAOI;IACE,WAAA;EALN;EAQE;IACE,sBAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;EANJ;EAQE;IACE,eAAA;EANJ;EAQE;IACE,aAAA;EANJ;AACF;AAUA;EAEI;IACE,iBAAA;EATJ;EAUI;IACE,aAAA;EARN;EAWE;IACE,iBAAA;EATJ;EAUI;IACE,WAAA;EARN;AACF","sourcesContent":[".ContactUs{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n  overflow: hidden;\n  position: relative;\n  .Contact{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 1rem;\n    padding: 1.25rem;\n    height: 100%;\n    width: 25rem;\n    background: var(--Foreground);\n    border-radius: 1rem;\n    overflow: hidden;\n    position: relative;\n    .ContactImage{\n      width: 75%;\n      height: 40%;\n      transition: opacity 0.3s ease;\n    }\n    .ContactImageDark{\n      opacity: 0.5;\n      transition: opacity 0.3s ease;\n    }\n    h1{\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: var(--TextColor);\n    }\n    .ConatactDetail{\n      width: 80%;\n      padding: 0.5rem;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.75rem;\n      border: 0.0625rem solid var(--Stroke);\n      border-radius: 0.25rem;\n      svg{\n        min-width: 1.25rem;\n        path{\n          fill: var(--AccentColor);\n        }\n      }\n      span{\n        font-size: 0.875rem;\n        color: var(--TextColor);\n      }\n      .Mail{\n        text-decoration: none;\n        color: #58A5E5;\n        font-size: 0.875rem;\n      }\n    }\n  }\n  .FormContainer{\n    flex: 1;\n    padding: 1.25rem;\n    height: 100%;\n    background: var(--Foreground);\n    border-radius: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.25rem;\n    transform-origin: top left;\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease-in-out;\n    transform: perspective(1500px) rotateY(-90deg);\n    h1{\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: var(--TextColor);\n      line-height: 100%;\n    }\n    span{\n      color: var(--TextColor);\n      font-size: 0.875rem;\n      text-align: center;\n      text-wrap: balance;\n    }\n    .InputSection{\n      padding-top: 2rem;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 2.5rem;\n      width: 60%;\n      overflow: auto;\n      .LoginInputContainer {\n        position: relative;\n        width: 100%;\n        min-width: 12.5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .EmailInput{\n          width: 100%;\n          height: 2.5rem;\n          padding: 0 0.75rem;\n          background: transparent;\n          border: None;\n          outline: None;\n          font-size: 0.875rem;\n          color: var(--TextColor);\n          border-bottom: 2px solid var(--Stroke);\n            &:-webkit-autofill {\n              background-color: transparent;\n              box-shadow: 0 0 0 100px white inset;\n              -webkit-text-fill-color: var(--TextColor) !important;\n          }\n        }\n        .EmailInput:read-only{\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n        .Select{\n          width: 100%;\n          background: transparent;\n          option{\n            background: var(--Background);\n            color: var(--TextColor);\n          }\n        }\n        .Select:read-only{\n          opacity: 1;\n          cursor: pointer;\n        }\n        .TextArea{\n          height: 6.25rem;\n          padding: 0.75rem 0 0 0.75rem;\n          font-size: 0.875rem;\n          border: 0.0625rem solid var(--Stroke);\n          border-bottom: 0.125rem solid var(--Stroke);\n          resize: none;\n          border-radius: 0.5rem;\n        }\n        .EmailLabel{\n          color: var(--TextColor);\n          font-size: 0.875rem;\n          position: absolute;\n          padding: 0 0.5rem;\n          top: 50%;\n          left: 0.75rem;\n          transform: translateY(-50%);\n          text-transform: capitalize;\n          transition: 0.2s;\n          pointer-events: none;\n        }\n        .EmailInput:not(:placeholder-shown)+.EmailLabel,\n        .EmailInput:focus+.EmailLabel {\n              background: var(--Foreground);\n              top: 0;\n              left: 0.5rem;\n              padding: 0 0.25rem;\n              font-size: 0.75rem;\n              color: var(--AccentColor);\n          }\n      }\n      .Button{\n        width: 100%;\n        min-height: 2.5rem;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        border: none;\n        background: var(--AccentColor);\n        border-radius: 0.25rem;\n        color: #fff;\n        font-size: 0.875rem;\n        cursor: pointer;\n      }\n    }\n  }\n  .Reveal{\n    transform: perspective(1500px) rotateY(0deg);\n    border-radius: 1rem;\n  }\n  .PinSection{\n    position: absolute;\n    height: 100%;\n    width: 3rem;\n    top: 0;\n    left: calc(25rem - 1.125rem);\n    background-repeat: space;\n    background-size: 100%;\n  }\n  .LoaderContainer{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 1;\n  }\n}\n \n@media (max-width: 1200px) {\n  .ContactUs{\n    .FormContainer{\n      .InputSection{\n        width: 90%;\n      }\n    }\n  }\n}\n \n@media (max-width: 824px) {\n  .ContactUs{\n    .Contact{\n      width: 18rem;\n      padding-top: 3rem;\n      justify-content: flex-start;\n      .ContactImage{\n        height: auto;\n      }\n      .ConatactDetail{\n        width: 100%;\n      }\n    }\n    .FormContainer{\n      justify-content: flex-start;\n      padding-top: 3rem;\n    }\n    .PinSection{\n      left: calc(18rem - 1.125rem);\n    }\n  }\n}\n\n@media (max-width:600px) {\n  .ContactUs{\n    flex-direction: column;\n    .Contact{\n      width: 100%;\n      flex: 1;\n      overflow: auto;\n      .ContactImage{\n        height: 30%;\n      }\n    }\n    .FormContainer{\n      transform-origin: none;\n      transform-style: none;\n      transition: none;\n      transform: none;\n    }\n    .Reveal{\n      transform: none;\n    }\n    .PinSection{\n      display: none;\n    }\n  }\n}\n\n@media (max-height:450px) {\n  .ContactUs{\n    .Contact{\n      padding-top: 1rem;\n      .ContactImage{\n        display: none;\n      }\n    }\n    .FormContainer{\n      padding-top: 1rem;\n      .InputSection{\n        gap: 1.5rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
